import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#111",
      d: "M2 4h12v1.333H2V4Zm0 3.333h12v1.334H2V7.333Zm0 3.334h12V12H2v-1.333Z"
    }, null, -1)
  ])))
}
export default { render: render }